import { Component, Output, EventEmitter } from '@angular/core';
import { LangService } from '../../services/lang.service';

@Component({
    selector: 'app-complete-details-banner',
    templateUrl: './complete-details-banner.component.html',
    styleUrls: ['./complete-details-banner.component.scss'],
    standalone: false
})
export class CompleteDetailsBannerComponent {
    @Output() bannerClick = new EventEmitter<void>();

    constructor(public lang: LangService) {}
}
